<div class="op-overview" [nbSpinner]="isLoading" nbSpinnerStatus="primary">
  <div class="page-head">
    <h1>Operation Overview</h1>
    <p>Every farm, block, and asset in one place — start here and drill into the detail you need.</p>
  </div>

  <div class="tiles">
    <div class="tile">
      <div class="k"><span class="dot" style="background:#253d5b"></span>Farms</div>
      <div class="v">{{ totalFarms }}</div><div class="sub">in operation</div>
    </div>
    <div class="tile">
      <div class="k"><span class="dot" style="background:#4a7c2f"></span>Blocks</div>
      <div class="v">{{ totalBlocks }}</div><div class="sub">across {{ totalFarms }} farms</div>
    </div>
    <div class="tile">
      <div class="k"><span class="dot" style="background:#e4572e"></span>Planted acres</div>
      <div class="v">{{ totalAcres | number:'1.0-0' }}<small>ac</small></div><div class="sub">GPS measured</div>
    </div>
    <div class="tile">
      <div class="k"><span class="dot" style="background:#6457a6"></span>Assets</div>
      <div class="v">{{ totalAssets }}</div><div class="sub">sensors &amp; infrastructure</div>
    </div>
    <div class="tile">
      <div class="k"><span class="dot" style="background:#d81e5b"></span>Varieties</div>
      <div class="v">{{ totalVarieties }}</div><div class="sub">{{ totalCrops }} crops</div>
    </div>
  </div>

  <div class="sec-head">
    <h2>Farms <span class="count">{{ totalFarms }}</span></h2>
    <div class="ctrls">
      <kw-view-toggle [storageKey]="viewStorageKey" [value]="view" (valueChange)="onViewChange($event)"></kw-view-toggle>
      <button type="button" class="btn-new" (click)="newFarm()"><span class="pc">+</span> New Farm</button>
    </div>
  </div>

  <div *ngIf="view === 'cards'">
    <div class="farm-grid" *ngIf="farms.length; else emptyState">
      <kw-farm-card *ngFor="let farm of farms"
        [farm]="farm"
        [acres]="acresFor(farm)"
        [blockCount]="blockCountFor(farm)"
        [assetCount]="assetCountFor(farm)"
        [varieties]="varietiesFor(farm)"
        (open)="openFarm(farm)">
      </kw-farm-card>
    </div>
  </div>

  <div *ngIf="view === 'table'">
    <ejs-grid *ngIf="farmColumns.length" #farmsGrid
      [dataSource]="farmRows"
      [columns]="farmColumns"
      [allowPaging]="true"
      [pageSettings]="pageSettings"
      [allowSorting]="true"
      [allowFiltering]="true"
      [filterSettings]="filterSettings"
      [allowResizing]="true"
      [enableStickyHeader]="true"
      [allowExcelExport]="true"
      [showColumnChooser]="true"
      [toolbar]="toolbar"
      (toolbarClick)="farmsToolbarClick($event)"
      (recordClick)="onFarmRowClick($event)"
      [height]="gridHeight">
    </ejs-grid>
    <div class="empty" *ngIf="!isLoading && !farmRows.length">No farms to show.</div>
  </div>

  <ng-template #emptyState>
    <div class="empty" *ngIf="!isLoading">No farms to show.</div>
  </ng-template>
</div>

<!-- grid cell templates (kept outside the grid per the project's Syncfusion convention) -->
<ng-template #farmNameTemplate let-data>
  <span class="cell-name">
    <span class="txt">{{ data.name }}</span>
  </span>
</ng-template>

<ng-template #farmOpenTemplate let-data>
  <button type="button" class="icon-btn" title="Open operation"
    (click)="openFarmById(data.id); $event.stopPropagation()">
    <fa-icon [icon]="faEye"></fa-icon>
  </button>
</ng-template>
